import React, { useState } from "react";
import { ToggleButtonGroup, ToggleButton } from "@/components/ToggleButton";
import { ns as baseNs } from "../config";
import ByCard from "./ByCard";
import BySbp from "./BySbp";
import type { TFunction } from "i18next";
import type { iRequestTaskPayoutDto } from "@/types";
import { tRootForm } from "./types";

const ns = baseNs + "tinkoffIndividuals.";
type tProps = {
  t: TFunction;
  onSubmit: (...args: any) => any;
};
const TinkoffIndividualsPayoutRequest = (props: tProps) => {
  const [method, setMethod] = useState("by_sbp");
  const onSubmit = (form: tRootForm) => {
    const payload: iRequestTaskPayoutDto = {
      tinkoffIndividuals: form,
    };
    return props.onSubmit(payload);
  };
  return (
    <>
      <ToggleButtonGroup value={method} onChange={setMethod}>
        {["by_sbp", "by_card"].map((method) => (
          <ToggleButton key={method} value={method}>
            {props.t(`${ns}payout_type.${method}`)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {method === "by_card" && (
        <ByCard ns={ns} t={props.t} onSubmit={onSubmit} />
      )}
      {method === "by_sbp" && <BySbp ns={ns} t={props.t} onSubmit={onSubmit} />}
    </>
  );
};

export default TinkoffIndividualsPayoutRequest;
